const template=`
<div class="widgetDetails">
  <div class="widgetContentMax insWidgetMax" ng-class="'max-' + widget.directive" style="width:720px;">
    <widget-status></widget-status>
    <generic-highchart chart-data="chartData" switcher="drillDown()" height="231" ng-hide="widgetIsLoading || serviceError || noDataFromServer || notConfigured"></generic-highchart>
  </div>
</div>`;
export default template;
